var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-list-wrapper",class:{ 'align-left': _vm.alignLeft, 'size-large': _vm.size === 'large' }},_vm._l((_vm.list),function(item,index){return _c('main-box-item',{key:`box_${index}`,attrs:{"item":item,"type":_vm.type,"size":_vm.size}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }